import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';
import { StepIconProps } from '@material-ui/core/StepIcon';
import { globalVal } from '../../global/globalvalues';
import './TrackOrder.scss';

const QontoConnector = withStyles({
    alternativeLabel: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    active: {
        '& $line': {
            borderColor: globalVal.primary_brand_color,
        },
    },
    completed: {
        '& $line': {
            borderColor: globalVal.primary_brand_color,
        },
    },
    line: {
        borderColor: '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
    },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
    root: {
        color: '#eaeaf0',
        display: 'flex',
        height: 22,
        alignItems: 'center',
    },
    active: {
        color: globalVal.primary_brand_color,
    },
    circle: {
        width: 12,
        height: 12,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
    circleActive: {
        width: 12,
        height: 12,
        borderRadius: '50%',
        backgroundColor: globalVal.primary_brand_color,
    },
    completed: {
        color: globalVal.primary_brand_color,
        zIndex: 1,
        fontSize: 18,
    },
});
function QontoStepIcon(props: StepIconProps) {
    const classes = useQontoStepIconStyles();
    const { active, completed } = props;

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
            })}
        >
            {completed ? <div className={classes.circleActive} /> : <div className={classes.circle} />}
        </div>
    );
}

type initialProps = {
    activeStep: number;
    getSteps: any;
};
export default function CustomizedSteppers(props: initialProps) {
    const activeStep = props.activeStep ? props.activeStep : 0;
    const steps = props.getSteps();

    return (
        <div>
            <div className="stepperComp">
                <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
                    {steps.map((item: any, index: number) => {
                        return index === 0 ? (
                            <Step key={item.label}>
                                <StepLabel StepIconComponent={QontoStepIcon}>{item.label}</StepLabel>
                                <div className={index <= activeStep ? 'textBelow fontWeight' : 'textBelow'}>
                                    {item.text &&
                                        item.text.split('\n').map((i: any) => {
                                            return <>{i}</>;
                                        })}
                                    {item && item.date && (
                                        <div className='textBelow fontWeight' style={{ marginTop:"0px"}}>
                                            {item.date}
                                        </div>
                                    )}
                                </div>
                                {/* <div className={index <= activeStep ? 'textBelow fontWeight' : 'textBelow'}>
                                    {item.simcards && `SIM cards: ${item.simcards}`}
                                </div> */}
                            </Step>
                        ) : (
                            <Step key={item.label}>
                                {' '}
                                <StepLabel StepIconComponent={QontoStepIcon}>{item.label}</StepLabel>
                                <div className={index <= activeStep ? 'textBelow fontWeight' : 'textBelow'}>
                                    {item.text &&
                                        item.text.split('\n').map((i: any) => {
                                            return <>{i}</>;
                                        })}
                                        {item && item.date && (
                                            <div className='textBelow fontWeight' style={{ marginTop:"0px"}}>
                                                {item.date}
                                            </div>
                                        )}
                                </div>
                            </Step>
                        );
                    })}
                </Stepper>
            </div>
            <div className="stepperCompVertical">
                <Stepper activeStep={activeStep} orientation="vertical" connector={<QontoConnector />}>
                    {steps.map((item: any, index: number) =>
                        index === 0 ? (
                            <Step key={item.label}>
                                <StepLabel StepIconComponent={QontoStepIcon}>{item.label} </StepLabel>
                                <div
                                    className={
                                        index < activeStep
                                            ? 'textBelow borderLeftCompleted'
                                            : index === activeStep
                                                ? 'textBelow borderLeft fontWeight'
                                                : 'textBelow borderLeft'
                                    }
                                >
                                    {item.time}
                                </div>
                                <div
                                    className={
                                        index < activeStep
                                            ? 'textBelow borderLeftCompleted'
                                            : index === activeStep
                                                ? 'textBelow borderLeft fontWeight'
                                                : 'textBelow borderLeft'
                                    }
                                >
                                    {item.date}
                                </div>
                                <div
                                    className={
                                        index < activeStep
                                            ? 'textBelow borderLeftCompleted'
                                            : index === activeStep
                                                ? 'textBelow borderLeft fontWeight'
                                                : 'textBelow borderLeft'
                                    }
                                >
                                    {item.simcards && `SIM cards: ${item.simcards}`}
                                </div>
                            </Step>
                        ) : (
                            <Step key={item.label}>
                                <StepLabel StepIconComponent={QontoStepIcon}>{item.label} </StepLabel>
                                <div
                                    className={
                                        index < activeStep
                                            ? 'textBelow borderLeftCompleted'
                                            : index === activeStep
                                                ? 'textBelow borderLeft fontWeight'
                                                : index === steps.length - 1
                                                    ? 'textBelow borderBottom '
                                                    : 'textBelow borderLeft'
                                    }
                                >
                                    {item.text &&
                                        item.text.split('\n').map((i: any) => {
                                            return <>{i}</>;
                                        })}
                                    {item && item.date && (
                                        <div className='textBelow' style={{ paddingLeft:"0", marginLeft:"0"}}>
                                            {item.date}
                                        </div>
                                    )}
                                </div>
                            </Step>
                        ),
                    )}
                </Stepper>
            </div>
        </div>
    );
}
